import React from "react";
import { useParams } from "react-router-dom";
import { Spin, Card, Typography, Space } from "antd";
import { useClassMarks } from "../hooks/useClassMarks";
import MarkForm from "../components/MarkForm";
import { useTranslation } from "react-i18next";
import { formatToFrenchDate } from "../../../../utils/dateUtils";
import { getSubjectLabelFromCode } from "utils/schoolUtils";
import Loader from "components/Common/loader";

const { Title, Text } = Typography;

const ClassMarksPage: React.FC = () => {
  const { classId = "", examSessionId = "" } = useParams<{ classId: string; examSessionId: string }>();
  const { t } = useTranslation();
  const { students, marks, examSession, loading, submitting, handleMarkChange, handleSubmitMarks } =
    useClassMarks(classId, examSessionId);

  if (loading) return <Loader />;

  return (
    <div className="page-wrapper">
      <div className="content">
        {examSession && (
          <Card className="mb-4 shadow-sm rounded p-4 bg-white">
            <Title level={4} className="mb-3 text-primary">
              {examSession.note}
            </Title>
            <div className="d-flex flex-column">
              <div className="d-flex align-items-center mb-2">
                <i className="ti ti-book me-2 text-primary"></i>
                <span>
                  <span className="fw-bold ">{t("subject")}:</span> {getSubjectLabelFromCode(examSession.examType?.subject?.code) ?? t("not_available")}
                </span>
              </div>
              <div className="d-flex align-items-center mb-2">
                <i className="ti ti-calendar me-2 text-primary"></i>
                <span>
                  <span className="fw-bold">{t("semester")}:</span> {examSession.semester}
                </span>
              </div>
              <div className="d-flex align-items-center">
                <i className="ti ti-clock me-2 text-primary"></i>
                <span>
                  <span className="fw-bold">{t("date_range")}:</span> {formatToFrenchDate(examSession.startDate)} - {formatToFrenchDate(examSession.endDate)}
                </span>
              </div>
            </div>
          </Card>

        )}
        <Card>
          <Title level={4}>
            {t("enter_marks")}
          </Title>
          <MarkForm
            students={students}
            marks={marks}
            submitting={submitting}
            handleMarkChange={handleMarkChange}
            handleSubmitMarks={handleSubmitMarks}
          />
        </Card>
      </div>
    </div>
  );
};

export default ClassMarksPage;
